export default "__VITE_PUBLIC_ASSET__42a57efc__"